export default {
	'de': {
			'grid': {
					'EmptyRecord': 'Keine Einträge vorhanden',
					'GroupDropArea': 'Ziehen Sie einen Spaltenkopf hier, um die Gruppe ihre Spalte',
					'UnGroup': 'Klicken Sie hier, um die Gruppierung aufheben',
					'EmptyDataSourceError': 'DataSource darf bei der Erstauslastung nicht leer sein, da Spalten aus der dataSource im AutoGenerate Spaltenraster',
					'Item': 'Artikel',
					'Items': 'Artikel',
					'Search': 'Suche',
					'Add': 'Hinzufügen',
					'Edit': 'Bearbeiten',
					'Cancel': 'Abbrechen',
					'Update': 'Aktualisieren',
					'Delete': 'Löschen',
					'EditOperationAlert': 'Keine Einträge fürs Bearbeiten selektiert',
					'DeleteOperationAlert': 'Keine Einträge fürs Löschen selektiert',
					'SaveButton': 'Speichern',
					'OKButton': 'OK',
					'CancelButton': 'Abbrechen',
			},
			'pager': {
					'pagerDropDown': 'Einträge pro Seite',
					'currentPageInfo': '{0} von {1} Seiten',
					'totalItemsInfo': '({0} Einträge)',
					'totalItemInfo': '({0} Eintrag)',
					'firstPageTooltip': 'Zur ersten Seite',
					'lastPageTooltip': 'Zur letzten Seite',
					'nextPageTooltip': 'Zur nächsten Seite',
					'previousPageTooltip': 'Zurück zur letzten Seit',
					'nextPagerTooltip': 'Gehen Sie zu den nächsten Pager-Elementen',
					'previousPagerTooltip': 'Gehen Sie zu vorherigen Pager-Elementen',
					'All': 'Alles',
			},
			'datepicker': {
				'today': "Heute",
			},	
		},
	'fr': {
		'grid': {
				'EmptyRecord' : "Aucune entrée n'est disponible",
				'GroupDropArea' : 'Faites glisser un en-tête de colonne ici pour grouper leur colonne',
				'UnGroup' : 'Cliquez ici pour annuler le regroupement',
				'EmptyDataSourceError' : 'DataSource ne doit pas être vide lors de la première utilisation, car les colonnes de dataSource sont dans la grille de colonnes AutoGenerate',
				'Item' : 'Article',
				'Items' : 'Articles',
				'Search' : 'Recherche',
				'Add' : 'Ajouter',
				'Edit' : 'Modifier',
				'Cancel' : 'Annuler',
				'Update' : 'Mettre à jour',
				'Delete' : 'Supprimer',
				'EditOperationAlert' : "Aucune entrée sélectionnée pour l'édition",
				'DeleteOperationAlert' : "Aucune entrée n'est sélectionnée pour la suppression",
				'SaveButton' : 'Enregistrer',
				'OKButton' : 'OK',
				'CancelButton' : 'Annuler',
		},
		'pager': {
				'pagerDropDown' : 'Entrées par page',
				'currentPageInfo' : '{0} de {1} pages',
				'totalItemsInfo' : '({0} entrées)',
				'totalItemInfo' : '({0} entrée)',
				'firstPageTooltip' : 'Vers la première page',
				'lastPageTooltip' : 'Vers la dernière page',
				'nextPageTooltip' : 'Vers la page suivante',
				'previousPageTooltip' : 'Retour à la dernière page',
				'nextPagerTooltip' : "Aller à l'élément de pagination suivant",
				'previousPagerTooltip' : 'Aller aux éléments de pager précédents',
				'All' : 'Tout',
		},
		'datepicker': {
			'today': "Aujourd'hui",
		},	
	},
	'it': {
		'grid': {
			'EmptyRecord': 'Nessuna voce disponibile',
			'GroupDropArea': "Trascina qui l'intestazione di una colonna per raggruppare la sua colonna",
			'UnGroup': 'Fare clic qui per disaggregare',
			'EmptyDataSourceError': "L'origine dati non deve essere vuota al momento del caricamento iniziale, perché le colonne dell'origine dati nella griglia di colonne AutoGenerate",
			'Item': 'Article',
			'Items': 'Article',
			'Search': 'Ricerca',
			'Add': 'Aggiungi',
			'Edit': 'Modifica',
			'Cancel': 'Annulla',
			'Update': 'Aggiorna',
			'Delete': 'Elimina',
			'EditOperationAlert': 'Nessuna voce selezionata per la modifica',
			'DeleteOperationAlert': "Nessuna voce selezionata per la cancellazione",
			'SaveButton': "Salva",
			'OKButton': "OK",
			'CancelButton': 'Annullare',
		},
		'pager': {
			'pagerDropDown': 'Voci per pagina',
			'currentPageInfo': '{0} di {1} pagine',
			'totalItemsInfo': '({0} voci)',
			'totalItemInfo': '({0} elementi)',
			'firstPageTooltip': 'Alla prima pagina',
			'lastPageTooltip': "All'ultima pagina",
			'nextPageTooltip': 'Alla pagina successiva',
			'previousPageTooltip': "Torna all'ultima pagina",
			'nextPagerTooltip': "Vai alle voci successive del pager",
			'previousPagerTooltip': "Vai agli elementi del pager precedente",
			'All': 'Tutti',
		},
		'datepicker': {
			'today': "Oggi",
		},
	},
}